import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-transaction-partialrefund-modal-shared",
  templateUrl: "./transaction-partialrefund-modal-shared.component.html",
  styleUrls: ["./transaction-partialrefund-modal-shared.component.scss"],
})
export class TransactionPartialrefundModalSharedComponent implements OnInit {
  @Input() pRefundModalPageOne: any;
  @Input() pRefundModalPageTwo: any;
  @Input() totalPartialRefund: any;
  @Input() refundProductList: any[];
  @Input() cRefundModalPageOne: any;
  @Input() totalCustomRefund: any;
  @Input() currency: any;
  @Input() transactionsForDropdown: any[] = [];
  @Input() paymentReceipt: any;
  @Input() selectedTransactionId: any;
  @Output() changeAmount: EventEmitter<any> = new EventEmitter();
  @Output() customChangeAmount: EventEmitter<any> = new EventEmitter();
  constructor() {}
  errorMsg = "";
  nCurrency: any;
  selectedTransaction: any = null;

  ngOnInit(): void {
    console.log("CURRENCY", this.currency);
    if (this.currency == undefined || this.currency == null || this.currency == "") {
      this.nCurrency = "$";
    } else {
      this.nCurrency = this.currency;
    }

    console.log("TOTAL PARTIAL REFUND:", this.totalPartialRefund);
  }
  // validateAmout() {
  //   if(this.total !== "") {
  //     this.total.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
  //   }
  // }
//   change(event: any) {
//     console.log("Partial-Event", event)
//     let data = event.value.replace(/\$/g, "");
//     if (data == "") {
//       this.errorMsg = "Please enter amount";
//     }
//     else {
//       this.errorMsg = "";
//       if (this.cRefundModalPageOne) {
//         this.customChangeAmount.emit(data);
//       } else {
//         this.changeAmount.emit(data);
//       }
//   }
// }
change(event: any) {
  console.log("Partial-Event", event.value)
  // let data = event.value.replace(/\$/g, "").trim();
  let data = event.value.replace(/[^0-9.]/g, "").trim();
  console.log("C-C-VALUE", typeof(data), data)
  if (data === "") {
    this.errorMsg = "Please enter amount";
  } else {
    const numericValue = parseFloat(data);
    if (isNaN(numericValue) || numericValue <= 0) {
      this.errorMsg = "Please add valid amount";
      this.customChangeAmount.emit(data);
    } else {
      this.errorMsg = "";
      if (this.cRefundModalPageOne) {
        // console.log("this.customChangeAmount.emit(data)", this.customChangeAmount.emit(data))
        this.customChangeAmount.emit(data);
      } else {
        // console.log("this.changeAmount.emit(data)", this.changeAmount.emit(data))
        this.changeAmount.emit(data);
      }
    }
  }
}

  checkProductSelected() {
    if (this.refundProductList.length > 0) {
      // console.log("PArtial-Products-T", this.refundProductList)
      return true;
    } else {
      // console.log("PArtial-Products-FALSE", this.refundProductList)
      return false;
    }
  }

  onTransactionSelect(transaction: any) {
    this.selectedTransaction = transaction;
    // Set the amount input to the selected transaction's amount
    this.totalPartialRefund = transaction.transactionAmount;
    // Emit the full transaction object (including transactionId and orderId)
    this.customChangeAmount.emit({
      amount: transaction.transactionAmount,
      transactionId: transaction.transactionId,
      orderId: this.paymentReceipt.orderId.orderId,
    });
  }
}
